import React, { useEffect, useState } from "react";
import styles from "./styles/Email.module.css"
import config from "../../../config";
import { UserData } from "../../../Context/DataContext";
import { useAuth } from "../../../Context/AuthContext";
import { decryptText, encryptText } from "../../../Utils/OstreonEncryption";
import { requestOTPsecret } from "../../../Utils/OTP";
import { updateSecret } from "../../../Utils/CustomerUser";
import { submitCaptcha } from "../../../Utils/captcha";
const base_url = config.base_url
function Email({ OnClose }) {
    
    const [code, setCode] = useState()
    const userData = UserData()
    const auth = useAuth()
    const email = auth.email
    const [emailM, setEmailM] = useState({
        "error": "",
        "success": ""
    })
    const [editable, setEditable] = useState(true)
    const [otp, setOTP] = useState("")
    const [otpM, setOTPM] = useState({
        "error": "",
        "success": ""
    })
    const encrypt_code = async (hash, code) => {
        console.log('No está cifrado')
        const encrypted = await encryptText(hash, code)
        // userData.setCustomerUser({...userData.CustomerUser, 'otp_secret':encrypted})
        // decrypt_code(hash, encrypted)
        updateSecret(encrypted)
        userData.getCustomerUser()
    }
    const decrypt_code = async (hash, code) => {
        console.log('Está cifrado')
        const decrypted = await decryptText(hash, code)
        setCode(decrypted)
    }
    useEffect(() => {
        if (userData?.CustomerUser.otp_secret.includes('-')) {
            console.log('Está cifrado')
            decrypt_code(auth.hash, userData?.CustomerUser.otp_secret)

        }
        else if (userData?.CustomerUser.otp_secret === '') {
            requestOTPsecret()
                .then(e => {
                    encrypt_code(auth.hash, e)
                    setCode(e)
                })
                .catch(e => {
                    // setError('Unable to retrieve a code')
                    setOTPM({ ...otpM, "error": "Unable to retrieve a code" })
                })
        }
        else {
            console.log('No está cifrado')
            if (auth.hash) {
                encrypt_code(auth.hash, code)
            }

        }
    }, [userData?.CustomerUser.otp_secret])
    useEffect(() => {
    }, [email, otp])
    const sendEmail = async () => {
        // if (!isValidEmail(email)){
        //     setEmailM({...emailM, "error":"Please enter a valid email address"})
        //     setTimeout(() => {
        //         setEmailM({
        //             "error":"",
        //             "success":""
        //         })
        //     }, 3000);
        //     return
        // }
        // console.log(email)
        console.log('click')
        const captcha_token = await submitCaptcha()
        fetch(base_url + 'user/sendOTP', {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-type': 'application/x-www-form-urlencoded',
                'credentials': 'include'
            },
            body: `token=${captcha_token}&secret=${code}`,
            credentials: 'include'
        }).then((res) => {
            return res.json()
        }).then(data => {
            if (data.error === "") {
                setEmailM({ ...emailM, "success": "Email sent" })
                setEditable(false)
            }
            else {
                setEmailM({ ...emailM, "error": "An error occurred" })
                setEditable(false)
            }
            setTimeout(() => {
                setEmailM({
                    "error": "",
                    "success": ""
                })
            }, 3000);
        }).catch(e=>{
            console.log(e)
            setEmailM({ ...emailM, "error": "An error occurred" })
        })
    }
    const validateOTP = () => {
        if (otp === "") {
            setOTPM({ ...otpM, "error": "Set a valid OTP" })
            setTimeout(() => {
                setOTPM({
                    "error": "",
                    "success": ""
                })
            }, 3000);
        }
        fetch(base_url + 'user/validateOTP', {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-type': 'application/x-www-form-urlencoded',
                'credentials': 'include'
            },
            body: `otp_code=${otp}&email=${email}&secret=${code}`,
            credentials: 'include'
        }).then((res) => {
            return res.json()
        }).then(data => {
            if (data.error === "") {
                setOTPM({ ...emailM, "success": "Correct OTP!" })
                userData.getCustomerUser()
                // userData.setCustomerUser({...userData.CustomerUser, 'otp_email':})
                setTimeout(() => {
                    OnClose()
                }, 1000);
            }
            else {
                setOTPM({ ...emailM, "error": "Invalid OTP" })
                setEditable(false)
            }
            setTimeout(() => {
                setOTPM({
                    "error": "",
                    "success": ""
                })
            }, 5000);
        })
    }
    useEffect(() => {
        document.documentElement.style.overflow = "hidden";
        return () => {
            document.documentElement.style.overflow = "unset";
        };
    }, []);
    return (
        <div className={styles.background}>
            <div onClick={(e) => { e.stopPropagation() }} className={styles.main_box} >
                <div onClick={OnClose} className={styles.close_logo} />
                <div className={styles.title}>Two-Step Login</div>
                <div className={styles.subtitle}>Email</div>
                <div className={styles.header}>
                    <div className={styles.email} style={{ visibility: "hidden" }} />
                    <div style={{ textAlign: 'center' }}>
                        <div>Follow these steps to set up two-step login with email:</div>
                        {userData?.CustomerUser?.otp_email ? <div>Your actual configuration sends OTP codes to {userData.CustomerUser.otp_email}</div> : null}
                    </div>


                    <div className={styles.email} />
                </div>
                <div className={styles.input_title}>1.The email where the OTP will be sent to:</div>
                <div disabled={!editable} value={email} className={styles.user_input} placeholder="Email">{userData.CustomerUser.otp_email}</div>
                {<div className={styles.login_error}>{emailM.error ? emailM.error : emailM.success}</div>}
                <div className={styles.footer}>
                    <div onClick={() => sendEmail()} className={styles.bluebutton}>Send Email</div>
                </div>
                <div className={styles.input_title}>2. Enter the resulting 6 digit verification code from the email</div>
                <input onChange={(e) => setOTP(e.target.value)} className={styles.user_input} placeholder="Code" />
                {<div className={styles.login_error}>{otpM.error ? otpM.error : otpM.success}</div>}
                <div className={styles.footer}>
                    <div onClick={() => validateOTP()} className={styles.bluebutton}>Enable</div>
                    <div onClick={OnClose} className={styles.whitebutton}>Cancel</div>
                </div>
            </div>
        </div>
    )

}
export { Email };